import React, { useState } from "react";
import Icon from "components/AppIcon";

function formatRupees(value) {
  if (value >= 10000000) return `₹${(value / 10000000)?.toFixed(1)}Cr`;
  if (value >= 100000) return `₹${(value / 100000)?.toFixed(1)}L`;
  return `₹${value?.toLocaleString("en-IN")}`;
}

export default function SalesFunnel({ onStageClick, stages }) {
  const [hoveredStage, setHoveredStage] = useState(null);
  const funnel = (stages || []).map((stage, index, arr) => {
    const maxDeals = arr[0]?.deals || 1;
    return {
      ...stage,
      conversion: stage.conversion ?? stage.conversionPercent ?? null,
      width: `${Math.max(Math.round((stage.deals / maxDeals) * 100), 24)}%`,
    };
  });
  const overallConv = funnel[0]?.deals ? ((funnel[funnel.length - 2]?.deals || 0) / funnel[0].deals) * 100 : 0;
  const avgDeal = funnel.reduce((acc, stage) => acc + stage.value, 0) / Math.max(funnel.reduce((acc, stage) => acc + stage.deals, 0), 1);

  return (
    <div
      className="card-base p-4 md:p-6 h-full"
      style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
    >
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg" style={{ color: "var(--color-foreground)" }}>
            Sales Funnel
          </h3>
          <p className="text-xs font-caption mt-0.5" style={{ color: "var(--color-text-secondary)" }}>
            Stage-by-stage conversion rates
          </p>
        </div>
        {funnel?.length > 0 && (
          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-caption font-medium"
            style={{ background: "var(--color-muted)", color: "var(--color-text-secondary)" }}>
            <Icon name="Filter" size={12} color="currentColor" />
            {funnel?.length} stages
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2">
        {funnel?.length === 0 && (
          <p className="font-caption text-sm text-center py-6" style={{ color: "var(--color-text-secondary)" }}>
            No pipeline data yet — deals will appear here
          </p>
        )}
        {funnel?.map((stage, idx) => (
          <div
            key={stage?.id}
            className="cursor-pointer group"
            onMouseEnter={() => setHoveredStage(stage?.id)}
            onMouseLeave={() => setHoveredStage(null)}
            onClick={() => onStageClick && onStageClick(stage)}
          >
            <div className="flex items-center gap-3 mb-1">
              <span className="text-xs font-caption w-24 flex-shrink-0" style={{ color: "var(--color-text-secondary)" }}>
                {stage?.label}
              </span>
              <div className="flex-1 relative h-8 rounded-md overflow-hidden" style={{ background: "var(--color-muted)" }}>
                <div
                  className="h-full rounded-md flex items-center px-3 transition-all duration-300"
                  style={{
                    width: stage?.width,
                    background: hoveredStage === stage?.id ? `${stage?.color}dd` : `${stage?.color}99`,
                    minWidth: "60px",
                  }}
                >
                  <span className="text-xs font-medium text-white whitespace-nowrap font-data">
                    {stage?.deals} deals
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-end w-20 flex-shrink-0">
                <span className="text-xs font-data font-medium" style={{ color: "var(--color-foreground)" }}>
                  {typeof stage?.value === "number" ? formatRupees(stage?.value) : stage?.value}
                </span>
                {stage?.conversion !== null && idx > 0 && (
                  <span className="text-xs font-caption" style={{ color: "var(--color-text-secondary)" }}>
                    {stage?.conversion}% conv.
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t grid grid-cols-3 gap-3" style={{ borderColor: "var(--color-border)" }}>
        <div className="text-center">
          <p className="text-lg font-heading font-bold" style={{ color: "var(--color-foreground)" }}>{overallConv.toFixed(1)}%</p>
          <p className="text-xs font-caption" style={{ color: "var(--color-text-secondary)" }}>Overall Conv.</p>
        </div>
        <div className="text-center">
          <p className="text-lg font-heading font-bold" style={{ color: "var(--color-foreground)" }}>{formatRupees(avgDeal)}</p>
          <p className="text-xs font-caption" style={{ color: "var(--color-text-secondary)" }}>Avg Deal Value</p>
        </div>
        <div className="text-center">
          <p className="text-lg font-heading font-bold" style={{ color: "var(--color-foreground)" }}>—</p>
          <p className="text-xs font-caption" style={{ color: "var(--color-text-secondary)" }}>Avg Cycle</p>
        </div>
      </div>
    </div>
  );
}